import type { PostHogContextRef } from '../context'

/**
 * Video playback events. Fire from `lib/components/VideoPlayer/`.
 */
export type PlaybackEvents = {
  video_started: () => void
}

export function createPlaybackEventCallbacks (
  contextRef: PostHogContextRef,
): PlaybackEvents {
  return {
    video_started: () => {
      const ctx = contextRef.current
      if (!ctx.posthogClient) return
      ctx.posthogClient.capture('video_started', {
        ...(ctx.eventContext && { context: ctx.eventContext }),
        playing_content_id: ctx.playingContentId,
        playing_feature_media_id: ctx.playingFeatureMediaId,
      })
    },
  }
}
